import pdpLoadProduct from './rbmc.pdp-load-product';
import pdpAddToCart from './rbmc.pdp-add-to-cart';
import pdpTooltips from './rbmc.pdp-tooltips';
import pdpConfig from './rbmc.pdp-configurator-field';
import pdpPatches from './rbmc.pdp-sponsor-patches';
import pdpFlockingWFL from './rbmc.wfl-flocking';
import Breakpoints from 'breakpoints-js/dist/breakpoints.min';
import Modal from 'bootstrap/js/src/modal';

const productDetails = {
    cdnUrl:                undefined,
    productWithFlock:      undefined,
    productFlockMandatory: undefined,
    configurationArea:     undefined,
    noReturns:             undefined,
    productInfoPanel:      undefined,
    noReturnsModal:        undefined,
    errorMessage:          undefined,
    mobileActiveFlag:      false,
    menuOpened:            false,
    trackingData:          RedBull.tracking,
    giftCard:              {
        message:    '',
        amount:     1,
        isGiftCard: false
    },

    partialAccordion() {
        $('.pdp__description-accordion-trigger').on('click', function () {
            $('.pdp__description-accordion').toggleClass('pdp__item-description--expand');
            $(this).toggleClass('pdp__description-collapsed');
        });
    },

    initializeBootstrapSelect() {
        $('#pdp__select-player').selectpicker({
            dropupAuto: false
        });

        $('.gift-card__style-select').selectpicker({
            dropupAuto: false
        }).on('changed.bs.select', event => {
            window.location.href = $(event.currentTarget).selectpicker('val')
        });
    },

    prepareComponentsAndFlag() {  //set control class if mobile loaded
        if (Breakpoints.is('desktop')) {
            productDetails.configurationArea
                          .removeClass('pdp__configurator-mobile')
                          .removeClass('pdp__configurator-open');
            productDetails.mobileActiveFlag = false;
        } else {
            productDetails.configurationArea
                          .addClass('pdp__configurator-mobile');
            productDetails.mobileActiveFlag = true;
            if (productDetails.menuOpened) {
                productDetails.configurationArea.addClass('pdp__configurator-open');
            }
        }
    },

    screenRotateHandle() { //check and set control class if high resolution mobile device used
        $(window).on('resize', function () {
            productDetails.prepareComponentsAndFlag();
            pdpTooltips.reloadTooltips();
        });
    },

    configuratorMobileEvents() { //specific configurator behaviour on mobile device
        productDetails.configurationArea.on('click', '.pdp__mobile-configurator-trigger', function () {
            productDetails.configurationArea
                          .addClass('pdp__configurator-open');
        })
    },

    noReturnsInfo() {
        if (pdpConfig.customNameFlag || pdpConfig.playerChosenFlag || pdpPatches.customPatch || pdpFlockingWFL.inputLocked) {
            this.noReturnsModal.modal('show');
        }
    },

    infoTextVisibility() {
        let $buyInfo    = productDetails.productInfoPanel.find('.pdp__buy-info'),
            $notifyInfo = productDetails.productInfoPanel.find('.pdp__notify-info');

        if (productDetails.productInfoPanel.find('#pdp__stock-status').val() === "true") {
            $buyInfo.removeClass('d-none');
            $notifyInfo.addClass('d-none');
        }

        if (productDetails.productInfoPanel.find('#pdp__notify-me-trigger').length) {
            $notifyInfo.removeClass('d-none');
            $buyInfo.addClass('d-none');
        } else {
            $buyInfo.removeClass('d-none');
            $notifyInfo.addClass('d-none');
        }
    },

    cacheSelectors() {
        const cdnMediaUrl                    = $('#pdp__cdn-media-url');
        productDetails.cdnUrl                = cdnMediaUrl.length ? cdnMediaUrl : null;
        productDetails.configurationArea     = $('#pdp__configuration-area');
        productDetails.productInfoPanel      = $('#productInfoPanel');
        productDetails.productWithFlock      = productDetails.configurationArea.data('flock-enabled');
        productDetails.productFlockMandatory = productDetails.configurationArea.data('flock-mandatory');
        productDetails.errorMessage          = $('.pdp__add-to-cart-error-wrapper');
    },

    bindMarkerEvent() {
        const productSection = $('.pdp__product-section');
        if (productSection.find('.pdp__marker-wrapper.has-info').length) {
            productSection.on('click', '.pdp__marker-wrapper.has-info', function () {
                $('#marker-info-modal').modal('show');
            });
        }
    },

    init() {
        productDetails.cacheSelectors();
        productDetails.prepareComponentsAndFlag();
        productDetails.screenRotateHandle();
        productDetails.configuratorMobileEvents();
        productDetails.initializeBootstrapSelect();
        productDetails.bindMarkerEvent();
        productDetails.giftCardBindings();

        if (productDetails.productWithFlock && !productDetails.productFlockMandatory && productDetails.cdnUrl) {
            pdpConfig.restoreOriginalImageSrc();
        }
    },

    initNoReturnsModal() {
        this.noReturnsModal = $('#no-returns-modal');

        new Modal(this.noReturnsModal[0], {
            show: false
        });
    },

    /**
     * If called without message, PDP error under add to cart button will be removed.
     * @param message
     */
    handleErrorMessage(message = null) {
        if (!!message) {
            productDetails.errorMessage.text(message);
            productDetails.errorMessage.removeClass('d-none');
        } else {
            productDetails.errorMessage.text('');
            productDetails.errorMessage.addClass('d-none');
        }
    },

    giftCardBindings() {
        productDetails.giftCard.isGiftCard = pdpConfig.configurationArea.data('gift-card');

        const $inputFieldCustomValue = productDetails.configurationArea.find('.gift-card__value-selector input[type=text]');
        // Free form price field action and frontend validation
        $inputFieldCustomValue.on('click change blur', function (e) {
            const $textInput   = $(e.target);
            let formattedValue = parseFloat($textInput.val()
                                                      .replace(/[^\d\-.,]/g, '')
                                                      .replace(/,/g, '.')
                                                      .replace(/\.(?=.*\.)/g, '')).toFixed(2);
            isNaN(formattedValue) ? formattedValue = '' : undefined;
            $textInput.val(formattedValue)
                      .parent().parent()
                      .find('input[type=radio]')
                      .val(formattedValue)
                      .prop('checked', true)
                      .trigger('change');
        });

        // For counter indicator of message length
        const $textArea = productDetails.configurationArea.find('.gift-card__textarea');
        $textArea.on('blur keyup input paste', (evt) => {
            const $this          = $(evt.currentTarget);
            const maxLength      = $textArea.data('message-length');
            const textAreaValue  = $this.val();
            const counterWrapper = $this.siblings('.gift-card__message-counter');
            const counter        = $this.siblings().find('.js-gift-card__message-length');
            $this.val(textAreaValue.replace(/(\r\n|\n|\r)/gm, evt.type === "paste" ? " " : ""));
            textAreaValue.length < maxLength ? counterWrapper.removeClass('error') : counterWrapper.addClass('error');

            if (textAreaValue.length <= maxLength) {
                productDetails.giftCard.message = textAreaValue;
                counter.text(textAreaValue.length);
            } else {
                $this.val(textAreaValue.substr(0, maxLength));
            }
        });
    },

    collectGiftCardData() {
        const $selectedGiftCardValue    = productDetails.configurationArea.find('input[type=radio]:checked')
        productDetails.giftCard.amount  = parseFloat($selectedGiftCardValue.val()).toFixed(2);
        productDetails.giftCard.message = productDetails.configurationArea.find('.gift-card__textarea').val();
        return productDetails.giftCard;
    },

    clearGiftCardMessage() {
        const $textarea = productDetails.configurationArea.find('.gift-card__textarea');
        if ($textarea.length) {
            $textarea.val('').trigger('blur');
        }
    },

    trackProductDetail() {
        // Track product detail
        if ('dataLayer' in window) {
            dataLayer.push(RedBull.tracking.pdp.UA);
            dataLayer.push(RedBull.tracking.pdp.GA4);
        }
    }
};

$(() => {
    const $pdpPage       = $('#product-detail-page');
    const isArchibaldPdp = $pdpPage.find('.archibaldPDP').length;

    if ($pdpPage.length && !isArchibaldPdp) {
        pdpLoadProduct.loadProduct();
        productDetails.partialAccordion();
        pdpAddToCart.bindHandler();
        productDetails.initNoReturnsModal();
    }
});

export default productDetails;
